import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PushPinIcon from '@mui/icons-material/PushPin';
import moment from 'moment';
import LeftStripeCard from '../../components/left-stripe-card';

const TYPE_COLORS = { 1: '#0EA5E9', 2: '#F59E0B', 3: '#EF4444' };

const AnnouncementCard = ({ item, selected, onClick, intl }) => {
  const unread = item.isread !== true;
  const typeColor = TYPE_COLORS[item.typeid] || TYPE_COLORS[1];
  return (
    <LeftStripeCard
      stripeColor={typeColor}
      selected={selected}
      onClick={onClick}
      sx={{
        mb: 1,
        ...(unread && !selected
          ? { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.06) }
          : {}),
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        {unread && (
          <Box
            component="span"
            sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: 'primary.main', flexShrink: 0 }}
          />
        )}
        {item.pinned && (
          <PushPinIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        )}
        <Tooltip title={item.title} arrow placement="top">
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: unread ? 700 : 400,
              color: unread ? 'text.primary' : 'text.secondary',
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {item.title}
          </Typography>
        </Tooltip>
        {item.hasattachments && (
          <AttachFileIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        )}
      </Box>
      <Typography
        variant="caption"
        sx={{ display: 'block', color: unread ? 'text.secondary' : 'text.disabled' }}
      >
        {item.authorname || ''}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 0.25 }}>
        <Typography variant="caption" sx={{ color: unread ? 'text.secondary' : 'text.disabled' }}>
          {item.publishdate ? moment(item.publishdate).format('DD/MM/YYYY HH:mm') : ''}
        </Typography>
        {unread && (
          <Typography
            variant="caption"
            sx={{ color: 'primary.main', fontWeight: 700, fontSize: 10, letterSpacing: 0.5, textTransform: 'uppercase' }}
          >
            Não lido
          </Typography>
        )}
      </Box>
    </LeftStripeCard>
  );
};

export default AnnouncementCard;
